import { defineComponent } from 'vue';
import { Configuration } from '@/Configuration';
export default defineComponent({
    computed: {
        version() {
            return Configuration.Version;
        }
    }
});
